import { useEffect, useRef, useState } from 'react';
import { getItem } from '../../utility/localStorageControl';

const SugesterChat = ({ scriptSrc }) => {
  if (!scriptSrc) return;

  const iframeRef = useRef(null);
  const userData = getItem('user_data');
  const [height, setHeight] = useState(140);
  const [width, setWidth] = useState(325);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'CHAT_OPENED') {
        console.log('Chat dimensions CHAT_OPENED:', event.data.width, event.data.height);
        // Możesz np. zapisać do state, by ustawić iframe dynamicznie
        setHeight(event.data.height);
        setWidth(event.data.width);
      }

      if (event.data?.type === 'ON_CHAT_HIDE') {
        console.log('Chat dimensions ON_CHAT_HIDE:', event.data.width, event.data.height);
        setHeight(event.data.height);
        setWidth(event.data.width);
        // Możesz np. zapisać do state, by ustawić iframe dynamicznie
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (!iframeRef.current) return;

    const doc = iframeRef.current.contentDocument;
    if (!doc) return;

    doc.open();
    doc.write(`
    <html>
      <head>
        <style>
        body {
            margin: 0 !important;
           
        }

        .sugester-chat-tab, .sugester-chat-box {
            left: 0 !important;
        }

         .sugester-chat-tab { 
           display: none; 
         }
        </style>
      
        <script>
          window.sugesterChatOptions = {
            login: "${userData?.email || 'Gość'}",
            client_id: "${userData?.login || 'anon'}",
            info: "e-mail: ${userData?.email}, login: ${userData?.login}, typ konta: ${userData?.entity_type?.label}"
          };
          window.ON_CHAT_SHOW = function () {
            const el = document.getElementById('sugester_chat_box1');
          const rect = el.getBoundingClientRect();

            parent.postMessage(
                {
                type: 'CHAT_OPENED',
                width: rect.width,
                height: rect.height,
                },
                '*'
            );
          };
          window.ON_CHAT_HIDE = function () {
            const el = document.getElementById('sugester_chat_tab1');
          const rect = el.getBoundingClientRect();

            parent.postMessage(
                {
                type: 'ON_CHAT_HIDE',
                width: rect.width,
                height: rect.height,
                },
                '*'
            ); 
          };

          function removeMediaQueriesAndForceDisplay() {
            for (let sheet of document.styleSheets) {
              try {
                for (let i = sheet.cssRules.length - 1; i >= 0; i--) {
                  const rule = sheet.cssRules[i];
                  if (rule.media || rule.cssText.includes('media')) {
                    sheet.deleteRule(i);
                  }
                }
           
                    sheet.insertRule(
                    '.sugester-chat-tab {  display: block;  }',
                    sheet.cssRules.length
                    );
                
              } catch (e) {
                // ignoruj błędy (np. CORS)
              }
            }
          }

        let attempts = 0;
        const interval = setInterval(() => {
            removeMediaQueriesAndForceDisplay();
            attempts++;
            if (attempts >= 10) clearInterval(interval);
        }, 300);

    
        </script>
      </head>
      <body>
        <script src="${scriptSrc}"></script>
      </body>
    </html>
  `);
    doc.close();
  }, []);

  return (
    <iframe
      ref={iframeRef}
      style={{
        width: width,
        height: height,
        border: 'none',
        position: 'fixed',
        bottom: '0',
        left: '10px',
        zIndex: 1000,
        backgroundColor: 'transparent',
      }}
      title="SugesterChat"
    />
  );
};

export default SugesterChat;
